// extracted by mini-css-extract-plugin
export default {"underDevelopment":"Placeholder_underDevelopment__8nAxm"};